import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import './styles/index.css'
import i18n from '../i18n.ts'

const app = createApp(App)

app.use(createPinia())
app.use(router).use(i18n)

app.mount('#app')
